import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { PayloadStates } from '@lore/utils';
import Loader from '@/components/Loader';
import useEventTags from '@/hooks/useEventTags';
import TagTypes from '@/constants/TagTypes';
import Callback from '@/components/Callback';
import { useUser } from '@lore/auth';
import useRouter from '@/hooks/useRouter';

Layout.propTypes = {
  event: PropTypes.shape({
    state: PropTypes.string
  }).isRequired
};

export default function Layout(props) {
  const { event } = props;

  const currentUser = useUser()
  const router = useRouter();

  const eventExpertiseTypes = useEventTags(event, TagTypes.ExpertiseType);

  if (
    event.state === PayloadStates.FETCHING ||
    eventExpertiseTypes.state === PayloadStates.FETCHING
  ) {
    return (
      <Loader />
    );
  }

  return (
    <Callback
      callback={() => router.navigate({
        pathname: `/invite`,
        search: queryString.stringify({
          expertiseTypes: eventExpertiseTypes.data.map(eventExpertiseType => eventExpertiseType._tag.id).join(','),
          locationCondition: JSON.stringify({
            address: currentUser.data.zipCode,
            latitude: currentUser.data.latitude,
            longitude: currentUser.data.longitude,
            radius: 50
          })
        })
      }, { replace: true })}
    />
  );
}
